"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="230689" id="hero" className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/florida_keys_coastal_home.png)]" style={{
      transform: "scale(1.05)"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-secondary/60 via-secondary/40 to-secondary/60" />

      {}
      <div ref={contentRef} className={`relative z-10 flex flex-col items-center justify-center text-center px-6 md:px-12 max-w-5xl mx-auto transition-all duration-1000 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <h1 className="font-default font-extrabold text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-tight mb-6" style={{
        letterSpacing: "-0.02em",
        color: "hsl(0 0% 100%)"
      }}>
          HOME INSPECTOR IN{" "}
          <span style={{
          color: "var(--primary)"
        }}>FLORIDA</span>
          {" "}KEYS
        </h1>

        {}
        <p className="font-default font-normal text-lg sm:text-xl max-w-2xl mb-10" style={{
        lineHeight: "1.7",
        color: "hsla(0, 0%, 100%, 0.9)"
      }}>
          Expert property evaluations for island living. We provide comprehensive inspections to protect your investment in the beautiful Florida Keys.
        </p>

        {}
        <Button asChild size="lg" className="font-default font-semibold text-base px-10 py-6 h-auto transition-all duration-300" style={{
        backgroundColor: "var(--primary)",
        color: "var(--primary-foreground)",
        borderRadius: "var(--radius)",
        boxShadow: "0 0 0 0px var(--primary)"
      }} onMouseEnter={e => {
        (e.currentTarget as HTMLElement).style.boxShadow = "0 0 0 2px var(--primary), 0 0 20px 4px hsla(25, 95%, 53%, 0.35)";
      }} onMouseLeave={e => {
        (e.currentTarget as HTMLElement).style.boxShadow = "0 0 0 0px var(--primary)";
      }}>
          <Link to="https://trusted-fl.com/#schedule-your-inspection">Schedule Inspection</Link>
        </Button>
      </div>

      {}
      <div className={`absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-10 transition-all duration-1000 delay-500 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <span className="font-mono text-xs tracking-widest uppercase" style={{
        color: "hsla(0, 0%, 100%, 0.7)",
        letterSpacing: "0.15em"
      }}>
          EXPLORE SERVICES
        </span>
        <ChevronDown className="size-5 animate-bounce" style={{
        color: "hsla(0, 0%, 100%, 0.7)"
      }} strokeWidth={1.5} />
      </div>
    </section>;
}